if (!customElements.get('mmx-sales-ingredients')) {
  customElements.define(
    'mmx-sales-ingredients',
    class MMXSalesIngredients extends HTMLElement {
      connectedCallback() {
        this.scroller = this.querySelector('[data-ingredients-scroller]');
        this.progress = this.querySelector('[data-ingredients-progress]');
        this.thumb = this.querySelector('[data-ingredients-progress-thumb]');
        if (!this.scroller || !this.progress || !this.thumb) return;

        this.updateProgress = this.updateProgress.bind(this);
        this.requestProgressUpdate = this.requestProgressUpdate.bind(this);
        this.scroller.addEventListener('scroll', this.requestProgressUpdate, { passive: true });

        this.resizeObserver = new ResizeObserver(this.requestProgressUpdate);
        this.resizeObserver.observe(this.scroller);
        this.resizeObserver.observe(this.progress);
        this.requestProgressUpdate();
      }

      disconnectedCallback() {
        this.scroller?.removeEventListener('scroll', this.requestProgressUpdate);
        this.resizeObserver?.disconnect();
        if (this.frame) cancelAnimationFrame(this.frame);
      }

      requestProgressUpdate() {
        if (this.frame) cancelAnimationFrame(this.frame);
        this.frame = requestAnimationFrame(this.updateProgress);
      }

      updateProgress() {
        this.frame = null;
        const maxScroll = Math.max(0, this.scroller.scrollWidth - this.scroller.clientWidth);
        const ratio = maxScroll > 0 ? Math.min(1, Math.max(0, Math.abs(this.scroller.scrollLeft) / maxScroll)) : 0;
        const visibleRatio = this.scroller.scrollWidth > 0
          ? Math.min(1, this.scroller.clientWidth / this.scroller.scrollWidth)
          : 1;
        const progressWidth = this.progress.clientWidth;
        const filledRatio = visibleRatio + ((1 - visibleRatio) * ratio);
        this.thumb.style.width = `${Math.round(progressWidth * filledRatio)}px`;
        this.progress.setAttribute('aria-valuenow', String(Math.round(filledRatio * 100)));
      }
    }
  );
}
